interface UpmodeLogoProps {
  collapsed?: boolean;
  width?: number;
  height?: number;
}

export function UpmodeLogo({ collapsed = false, width, height }: UpmodeLogoProps) {
  // Optional sizing support (applies to the wrapper)
  const sizeStyle =
    width || height
      ? {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: width ? `${width}px` : undefined,
          height: height ? `${height}px` : undefined,
        }
      : undefined;

  if (collapsed) {
    return (
      <span
        style={{
          ...(sizeStyle || {}),
          color: "var(--foreground)",
          fontSize: "var(--text-2xl)",
          fontWeight: "var(--font-weight-bold)",
          letterSpacing: "-0.03em",
        }}
      >
        U
      </span>
    );
  }

  return (
    <span
      style={{
        ...(sizeStyle || {}),
        color: "var(--foreground)",
        fontSize: "var(--text-2xl)",
        fontWeight: "var(--font-weight-bold)",
        letterSpacing: "-0.03em",
        lineHeight: "1",
        whiteSpace: "nowrap",
      }}
    >
      Upmode
    </span>
  );
}